/* eslint-disable */
import * as React from 'react';
import { dateDiff } from '../../../helpers';
import logUsage from '../../../utilities/log-usage';
import SPGVariables from '../../../utilities/spg-variables';

const spgVariables = SPGVariables();

const PageLoaded = function PageLoaded({ keyPage, startDate }: PageProps) {
    if (spgVariables.IS_CRAWLER_REQUEST) return null;
    const metrics = {
        pageStartTime: startDate,
        pageEndTime: new Date(),
        Browser: {
            ScreenWidth: screen.width,
            ScreenHeight: screen.height,
            Width: window.innerWidth,
            Height: window.innerHeight
        } as AnonymousObject
    };
    if (startDate) logUsage(keyPage, Math.round(dateDiff(metrics.pageEndTime, startDate) / 1000));
    import('../../../utilities/application-insights').then(AppInsights => {
        if (AppInsights && startDate) {
            const appInsights = AppInsights.default;
            if (appInsights) {
                // please do not remove this console log. it is intentionally added for QA team. Thanks!
                console.log('MILoggingStats.duration', dateDiff(startDate));
                appInsights.trackPageView({
                    name: keyPage.toString(),
                    uri: window.location.href,
                    properties: { duration: dateDiff(startDate), routePath: window.location.pathname, metrics }
                });
            }
        }
    });
    return null;
};

export default React.memo(PageLoaded);
